import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as Parse from 'parse';
@Injectable({
  providedIn: 'root'
})
export class AdminService {
  users = new BehaviorSubject<any[] | null>(null);
  users$ = this.users.asObservable();
  userCount = new BehaviorSubject<number | null>(null);
  userCount$ = this.userCount.asObservable();
  adCount = new BehaviorSubject<number | null>(null);
  adCount$ = this.adCount.asObservable();
  constructor() { }


  getUsers(displayLimit: number, page: number, filter?: string): Promise<void> {
    return Parse.Cloud.run('getUsers', { displayLimit, page, filter }).then((result) => {
      this.users.next(result);
    });
  }

  getUserRequests(): Promise<void> {
    return Parse.Cloud.run('getUserRequests', { });
  }

  getUserCount(filter?: string): Promise<number>{
    return Parse.Cloud.run('getUserCount', {filter}).then((result) => {
      this.userCount.next(result);
    });;
  }

  getAdCount(): Promise<number>{
    return Parse.Cloud.run('getAdCount').then((result) => {
      this.adCount.next(result);
    });;
  }

  sendRenewalNotice(user: any){
    return Parse.Cloud.run('sendRenewalNotice', {user});
  }
}
